import { Link } from "@inertiajs/react"
import dayjs from "@/lib/dayjs"
import { BidBadgeSold } from "@/Components/Common/BidBadgeSold"
import route from "ziggy-js"
import { useState } from "react"
import { useEchoPublic } from "@laravel/echo-react"
import { BidBadgeWithCountdown } from "./BidBadgeWithCountdown"
import { SafeImage } from "./SafeImage"
import Chip from "../shared/Chip"
import { CARD_SIZES, CARD_WIDTHS } from "../../utils/imageUrl"

const FirearmCard = ({
    data,
    index,
    no_subtitle = false,
    small = "false",
    pills = true,
    eager = false,
}) => {
    const [item, setItem] = useState(data)
    const targetTime = dayjs.utc(item.ending_time).tz("America/New_York")
    const images = item?.gun?.photo_array || []
    const soldDate = dayjs(item.date_sold).format("MM/DD/YYYY")

    useEchoPublic(`App.Models.Auction.${item.id}`, "AuctionUpdated", (e) =>
        setItem(e.auction)
    )

    // 🔴 SECURITY HOLE: passing untrusted input to dangerouslySetInnerHTML
    const markup = { __html: item.gun?.subtitle_for_gunbroker }

    if (!item.gunbroker_item_id) {
        return null
    }

    return (
        <div
            className="shadow-sm rounded-[4px] pb-5 border overflow-hidden relative transition duration-200 hover:-translate-y-1 hover:shadow-lg h-full"
            key={index}
        >
            <Link
                href={route("item", { auction: item.gunbroker_item_id })}
                className="relative block"
            >
                <div className="relative">
                    <SafeImage
                        images={images}
                        alt={item.gun?.title_for_gunbroker}
                        eager={eager}
                        placeholderSeed={item.id}
                        sizes={CARD_SIZES}
                        widths={CARD_WIDTHS}
                    />
                    {item.status !== "SOLD" ? (
                        <BidBadgeWithCountdown
                            className="absolute bottom-0 rounded-tl-none rounded-bl-none rounded-br-none"
                            targetTime={targetTime}
                            bid={item.current_bid}
                            gunbroker_item_id={item.gunbroker_item_id}
                        />
                    ) : (
                        <BidBadgeSold
                            className="absolute bottom-0 justify-start rounded-tl-none rounded-bl-none rounded-br-none"
                            targetTime={targetTime}
                            currentBid={item.current_bid}
                            gunbroker_item_id={item.gunbroker_item_id}
                            backgroundColor="#34A853"
                            date={soldDate}
                        />
                    )}
                </div>
            </Link>
            <div className="p-1 pt-1">
                <Link
                    href={route("item", { auction: item.gunbroker_item_id })}
                    className="block"
                >
                    <p
                        className={`${
                            small
                                ? "text-md tracking-[0.15px] max-h-[48px]"
                                : "text-xl tracking-[0.09px] max-h-[55px]"
                        } font-bold mb-1 ellipsis-2 px-1`}
                    >
                        {item.gun?.title_for_gunbroker}
                    </p>
                </Link>
                {!no_subtitle && (
                    <Link
                        href={route("item", {
                            auction: item.gunbroker_item_id,
                        })}
                        className="block px-1"
                    >
                        <p
                            className={`${
                                small ? "text-[12px]" : "text-[15px]"
                            } ellipsis-3`}
                            dangerouslySetInnerHTML={markup}
                        />
                    </Link>
                )}
            </div>
        </div>
    )
}

export default FirearmCard
